import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
    selector: 'aira-pills',
    templateUrl: './aira-pills.component.html',
    styleUrl: './aira-pills.component.css',
    standalone: false
})
export class AiraPillsComponent {
  @Input() label;
  @Input() data;
  @Input() previewOnly: boolean = false;

  pillsToRender: any[] = [];
  leftoverCount: number = 0;
  renderData: any[] = [];

  ngOnInit() {
    this.rebuildPills();
  }

  ngOnChanges() {
    this.rebuildPills();
  }

  rebuildPills(): void {
    this.renderData = this.getPreviewData() || this.data || [];
    this.pillsToRender = [];
    this.leftoverCount = 0;
    this.handlePillsData();
  }

  handlePillsData() {
    if (!this.renderData.length) return;

    if (this.renderData.length <= 5) {
      this.pillsToRender = this.renderData;
      return;
    }

    if (this.renderData.length > 5) {
      this.leftoverCount = this.renderData.length - 5;
      this.pillsToRender = this.renderData.slice(0, 5);
    }
  }

  showAllPills(): void {
    this.pillsToRender = this.renderData;
    this.leftoverCount = null;
  }

  getPreviewData(): any[] {
    if (!this.previewOnly) return null;
    const labelLowered = (this.label || '').toLowerCase();
    if (labelLowered.includes('product')) {
      return magicPreviewDummyData.pillsProducts;
    } else if (labelLowered.includes('factors')) {
      return magicPreviewDummyData.pillsFactors;
    }
    return this.data;
  }
}
